import { render } from "./pie.vue?vue&type=template&id=049187b2&scoped=true&ts=true"
import script from "./pie.vue?vue&type=script&lang=ts"
export * from "./pie.vue?vue&type=script&lang=ts"

import "./pie.vue?vue&type=style&index=0&id=049187b2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Dell\\latam\\latamlogistichn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049187b2"]])

export default __exports__